var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload011(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-01 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.88817 26.0842C5.67842 26.0434 5.48077 25.9552 5.31031 25.8264C5.13986 25.6975 5.00112 25.5314 4.9047 25.3407C4.80997 25.1426 4.75557 24.9276 4.74465 24.7083C4.74465 22.9014 4.74465 21.1229 4.74465 19.3289C4.74267 19.2979 4.74267 19.2669 4.74465 19.2359H7.46536V23.3273H22.5918V19.2359H25.3461V24.3986C25.3461 25.3872 25.1086 25.7305 24.1871 26.0738L5.88817 26.0842Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9763 13.7377V13.4796C12.9763 10.6505 12.9763 7.82224 12.9763 4.99484C12.9763 4.3934 13.2215 4.14817 13.8204 4.14817H16.3087C16.825 4.14817 17.0986 4.4063 17.0986 4.94321V13.7377H17.3413C18.1337 13.7377 18.9288 13.7377 19.7238 13.7377C19.8742 13.7191 20.0267 13.7479 20.16 13.8201C20.2932 13.8923 20.4007 14.0043 20.4672 14.1404C20.5308 14.2797 20.5478 14.4358 20.5157 14.5855C20.4836 14.7352 20.4042 14.8706 20.2891 14.9716L15.6247 20.2814C15.2556 20.7047 14.8219 20.7073 14.4554 20.2814C12.8945 18.5071 11.3345 16.7303 9.77544 14.951C9.6661 14.8521 9.59076 14.7213 9.56016 14.5772C9.52957 14.433 9.54528 14.2829 9.60507 14.1482C9.669 14.011 9.7744 13.8973 9.90639 13.8232C10.0384 13.7491 10.1903 13.7183 10.3407 13.7352C11.1358 13.7352 11.9308 13.7352 12.7233 13.7352L12.9763 13.7377Z",
    fill: "#999999"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload011);
export default __webpack_public_path__ + "static/media/download-01 1.a05bf5ed8fa8551a477a6ae8c7704d0f.svg";
export { ForwardRef as ReactComponent };